export const INPUT_DATE = 'dd/MM/yyyy';
export const INPUT_DATEPICKER = 'DD/MM/YYYY';
